import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
function Google() {
    const { t } = useTranslation();
    return (_jsxs(_Fragment, { children: [_jsx("h2", { children: t("dataImport.instructions.exportGoogle") }), _jsx("ol", { children: _jsxs("li", { children: [t("dataImport.instructions.goTo"), " ", _jsx("a", { href: "https://takeout.google.com", target: "_blank", rel: "noreferrer", children: "Google Takeout" })] }) })] }));
}
export default Google;
